/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const FLATMATES: CommunityData = {
  code: "flatmates",
  inviteCode: "flatmates",
  name: "Flat Mates",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/fla-046`,
  socials: {},
  styles: {
    global: {
      counterColor: "#f990b1",
      logo: {
        src: "https://media.werz.at/community-assets/FLATMATES/web-logo.png",
        styles: "w-[160px] h-[148px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/FLATMATES/web-alternative-logo.png",
        styles: "w-[160px] h-[148px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#222222",
      asideBg: "#f990b1",
      asideStyles: "bg-[#f990b1]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/FLATMATES/web-bg.jpg",
      bgMobile: "https://media.werz.at/community-assets/FLATMATES/web-bg.jpg",
      nonMemberBg: "https://media.werz.at/community-assets/FLATMATES/web-non-member-bg.png?v=2",
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#f990b1] border-2 border-[#f990b1] rounded-lg px-[18px] py-[18px] !text-[#222222] font-['RetroCoolRegular'] !text-[24px] uppercase text-left !leading-[150%]",
      scrollArrow: {
        background: "#f990b1",
        color: "#222222",
      },
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "",
      separator: "#30303080",
      item: "text-[#000000] font-['RetroCoolRegular'] text-[20px] uppercase text-left gap-x-[10px] -ml-2 text-opacity-50 text-center border-b border-[#30303080]",
      itemSelected: "text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#222222] rounded-[24px] !pb-8 overflow-hidden",
      titles: "text-[#f990b1] font-['HelveticaNeueBold'] text-[32px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['HelveticaNeueRegular'] text-[15px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#f990b1] font-['HelveticaNeueBold'] text-[32px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container: "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-[16px]",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-[16px]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#f990b1] font-['HelveticaNeueBold'] text-[24px] text-left leading-[100%]",
          subtitle: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[15px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#f990b1] font-['HelveticaNeueBold'] text-[32px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00] !rounded-[16px]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative overflow-hidden !rounded-[16px]",
          media: "w-full !aspect-video object-cover !rounded-[16px]",
          placeholderMedia: "w-full h-full bg-gray-400 !rounded-[16px]",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title: "text-[#f990b1] font-['HelveticaNeueBold'] sm:text-[16px] text-left text-[24px]",
          subtitle: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left",
          location: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left",
          date: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#f990b1] font-['HelveticaNeueBold'] text-[28px] text-left leading-[100%]",
        text: "text-[#f990b1] font-['HelveticaNeueRegular'] text-[17px] text-left",
        customShopImageStyle: "rounded-[16px]",
        sectionTitle:
          "text-[#f990b1] font-['HelveticaNeueBold'] text-[28px] text-left leading-[100%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#222222] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-[16px] !border-0",
        title: "text-[#f990b1] font-['HelveticaNeueBold'] text-[32px] text-left leading-[100%]",
        subtitle: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[15px] text-left mb-4 mt-2",
        button:
          "bg-[#f990b1] border-2 border-[#f990b1] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['RetroCoolRegular'] text-[24px] uppercase text-left",
        questions: "text-[15px] text-left text-[#f990b1]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#f990b1] font-['HelveticaNeueBold'] text-[28px] text-left leading-[100%]",
        text: "text-[#f990b1] font-['HelveticaNeueRegular'] text-[15px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#f990b1] font-['HelveticaNeueBold'] text-[28px] text-left leading-[100%]",
        text: "text-[#f990b1] font-['HelveticaNeueRegular'] text-[15px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] rounded-[16px]",
        mapPinColor: "#f990b1",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#f990b1] font-['HelveticaNeueBold'] text-[28px] text-left leading-[100%]",
        text: "text-[#f990b1] font-['HelveticaNeueRegular'] text-[15px] text-left",
      },
      tickets: {
        header:
          "text-[#f990b1] font-['HelveticaNeueBold'] text-[32px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#222222] rounded-[24px] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#f990b1] rounded-lg px-4 py-3 text-[#222222] font-['RetroCoolRegular'] text-[18px] text-left !w-fit uppercase",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 !border-b !border-[#30303080]",
          media: "!hidden",
          name: "text-[#f990b1] font-['HelveticaNeueBold'] text-[16px] text-left",
          description:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[15px] text-left leading-[120%] !mt-1",
          price:
            "text-[#ffffff] font-['HelveticaNeueBold'] text-[16px] text-left leading-[100%] !mt-1",
          quantity: "text-[#222222] font-['RetroCoolRegular'] text-[18px] text-left mt-1",
          status: "text-[#ffffff] font-['HelveticaNeueBold'] text-[16px] text-left leading-[100%]",
          counterContainer:
            "bg-[#f990b1] border-2 border-[#f990b1] rounded-lg px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "!bg-[#f990b1] rounded-lg px-4 py-3 text-[#222222] font-['RetroCoolRegular'] text-[18px] text-left !w-fit uppercase",
          plusMinusColor: "#222222",
        },
      },
    },
  },
}

export default FLATMATES
